import { useEffect, useState } from "react";
import api from "@/lib/api";

// Convert any pasted video link into an embeddable source.
const toEmbed = (raw) => {
  const url = (raw || "").trim();
  let m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([\w-]{11})/);
  if (m) return { type: "iframe", src: `https://www.youtube.com/embed/${m[1]}?rel=0&modestbranding=1` };
  m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (m) return { type: "iframe", src: `https://player.vimeo.com/video/${m[1]}` };
  if (/\.(mp4|webm|ogg)(\?|$)/i.test(url)) return { type: "video", src: url };
  return { type: "iframe", src: url };
};

export const VideoAdBanner = () => {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/video-ads").then((r) => setAds(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (ads.length <= 1) return undefined;
    const id = setInterval(() => setIdx((i) => (i + 1) % ads.length), 15000);
    return () => clearInterval(id);
  }, [ads]);

  if (ads.length === 0) return null;
  const ad = ads[Math.min(idx, ads.length - 1)];
  const e = toEmbed(ad.embed_url);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-testid="video-ad-banner">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-display font-bold text-2xl sm:text-3xl">{ad.title || "Featured"}</h2>
        <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground border border-border/60 rounded-full px-2 py-0.5">Sponsored</span>
      </div>
      <div className="relative rounded-2xl overflow-hidden bg-black aspect-video border border-border/50">
        {e.type === "video" ? (
          <video key={e.src} src={e.src} controls autoPlay muted loop playsInline className="w-full h-full object-contain" />
        ) : (
          <iframe
            key={e.src}
            src={e.src}
            title={ad.title || "Video advertisement"}
            className="w-full h-full"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>
      {ads.length > 1 && (
        <div className="flex justify-center gap-2 mt-3">
          {ads.map((a, i) => (
            <button
              key={a.video_ad_id}
              type="button"
              data-testid={`video-ad-dot-${i}`}
              onClick={() => setIdx(i)}
              aria-label={`Show video ${i + 1}`}
              className={`h-2 rounded-full transition-all ${i === idx ? "w-6 bg-primary" : "w-2 bg-muted-foreground/40 hover:bg-muted-foreground/70"}`}
            />
          ))}
        </div>
      )}
    </section>
  );
};
